import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=ae575a8a&scoped=true&"
import script from "./TaskPage.vue?vue&type=script&lang=js&"
export * from "./TaskPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskPage.vue?vue&type=style&index=0&id=ae575a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae575a8a",
  null
  
)

export default component.exports